import { render } from "./_PanelBasicData.vue?vue&type=template&id=3a1324af"
import script from "./_PanelBasicData.vue?vue&type=script&lang=js"
export * from "./_PanelBasicData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__